import React from 'react';
import { Table, columnDefiner } from '../../atomic/table';
import { KintoneApp } from '../../../models/TenantModel';
import { IconButton } from '../../atomic/buttons';
import { Link } from 'react-router';
import { Icon, Icons } from '../../atomic/icons';
import { AdminKintoneAppFolderList } from './AdminKintoneAppFolderList';
import { getKintoneAppFolders } from '../../../APIs/foldersApi';

interface AppData extends KintoneApp {
    trClass: string;
}

const definer = columnDefiner<AppData>();
const columns = [
    definer.accessor('appId', {
        header: 'AppId',
        cell: (d) => {
            const { appId } = d.row.original;
            return (
                <>
                    <Link to={`/app/admin/kintone/app/${appId}/edit`}>
                        <Icon icon="fa-solid fa-pencil"></Icon>
                        {appId}
                    </Link>
                </>
            );
        },
    }),
    {
        header: '詳細',
        cell: (d: { row: { original: { appDescription: any } } }) => {
            const appDescription =
                d.row.original.appDescription == null
                    ? ''
                    : d.row.original.appDescription;
            return `${appDescription}`;
        },
    },
    {
        header: '連携先フォルダ',
        cell: (d: {
            row: {
                original: {
                    items: any;
                    appId: any;
                    update: any;
                };
            };
        }) => {
            const folders = d.row.original.items ? d.row.original.items : [];
            const appId = d.row.original.appId;
            const update = d.row.original.update;

            if (!update) {
                return <Icon icon={Icons.Spinner} />;
            }

            return (
                <AdminKintoneAppFolderList appId={appId} folders={folders} />
            );
        },
    },
    {
        header: '削除',
        cell: (d: {
            row: { original: { appId: any } };
            table: { options: { onRemoveApp: any } };
        }) => {
            const { appId } = d.row.original;
            const { onRemoveApp } = d.table.options;
            return (
                <IconButton
                    icon="fa-solid fa-trash"
                    onClick={() => {
                        onRemoveApp(Number(appId));
                    }}
                ></IconButton>
            );
        },
    },
];

type AdminKintoneTableProp = {
    apps;
    setApps;
    onRemoveApp;
};

export const AdminKintoneTable: React.FC<AdminKintoneTableProp> = ({
    apps,
    setApps,
    onRemoveApp,
}) => {
    const options = {
        onRemoveApp,
    };

    React.useEffect(() => {
        const ids = apps.map((app) => app.appId.toString()) as Array<string>;
        const fetchData = async (ids) => {
            const resp = await getKintoneAppFolders(ids);
            const folders = resp.data;

            if (folders) {
                setApps((apps) => {
                    const _apps = [...apps];
                    folders.forEach((_folder) => {
                        for (const [index, app] of _apps.entries()) {
                            if (
                                app.appId.toString() == _folder.appId.toString()
                            ) {
                                _apps[index].items = _folder.items;
                                _apps[index].update = true;
                                break;
                            }
                        }
                    });
                    return _apps;
                });
            }
        };

        const splitArray = (array: string[], sliceSize = 20) => {
            const result: string[][] = [];
            for (let i = 0; i < array.length; i += sliceSize) {
                result.push(array.slice(i, i + sliceSize));
            }
            return result;
        };
        splitArray(ids).forEach((_ids) => fetchData(_ids));
    }, []);

    return (
        <>
            <Table
                className="app-table"
                data={apps}
                columns={columns}
                options={options}
            />
        </>
    );
};
